export default {
     SET_COACH_DATA(state,value){
          state.coachData = value
     }
};
